import { render, staticRenderFns } from "./ModalCriarModelos.vue?vue&type=template&id=4733c198&scoped=true&"
import script from "./ModalCriarModelos.vue?vue&type=script&lang=js&"
export * from "./ModalCriarModelos.vue?vue&type=script&lang=js&"
import style0 from "./ModalCriarModelos.vue?vue&type=style&index=0&id=4733c198&lang=scss&scoped=true&"
import style1 from "./ModalCriarModelos.vue?vue&type=style&index=1&id=4733c198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733c198",
  null
  
)

export default component.exports